import { useEffect, useState } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { useCurrentStateAndParams } from '@uirouter/react';
import { dataMonitorPageStateAtom } from '../datamonitor_list_atoms';
import { ngContext } from '../../../../core/services/ng.delegate';
import utilSvc from '../../../../core/utilSvc';
import { ValidOption } from '../../../../core/components/validation/types';

export const useDataMonitorInit = (): boolean => {
    const [ready, setReady] = useState(false);
    const setState = useSetImmerAtom(dataMonitorPageStateAtom);
    const { params: routeParams } = useCurrentStateAndParams();

    useEffect(() => {
        const ctx = ngContext();
        const isVerity = ctx.User?.Type === 'VERITY' || ctx.User?.Type === 'VERITYSA';
        const affs = utilSvc.aff.findStatus(ctx.User?.AffList ?? []);
        const ceDroplist = utilSvc.aff.ceDroplist(affs, undefined, false, true) ?? [];
        const ceOptions: ValidOption[] = ceDroplist.map((ce: any) => ({
            lbl: ce.value === 'ALL' ? 'All Facilities' : ce.label,
            val: ce.value,
        }));

        // In-app alert deep-link: land on Monitor Status, facility ALL, filtered to this MonitorType.
        const deepLinkMonitorType =
            typeof routeParams.MonitorType === 'string' && routeParams.MonitorType ? routeParams.MonitorType : null;
        const hasAllOption = ceOptions.some(o => String(o.val) === 'ALL');

        let defaultVal = '';
        let valid = false;

        // Filter out the ALL option to count real facilities
        const realOptions = ceOptions.filter(
            o => String(o.val) !== 'ALL' && String(o.val) !== 'NONE' && String(o.val) !== '',
        );

        if (deepLinkMonitorType && hasAllOption) {
            // Deep-link forces facility ALL so the alert's MonitorType is visible across facilities.
            defaultVal = 'ALL';
            valid = true;
        } else if (realOptions.length > 1) {
            // Multiple real facilities — select ALL
            defaultVal = 'ALL';
            valid = true;
        } else if (realOptions.length === 1) {
            // Single facility — auto-select it
            defaultVal = String(realOptions[0].val);
            valid = true;
        }

        setState(draft => {
            draft.facility.options = ceOptions;
            draft.facility.val = defaultVal;
            draft.facility.valid = valid;
            // Deep-link always lands on Monitor Status; otherwise VERITY defaults to System.
            draft.activeTab = deepLinkMonitorType ? 'MONITORS' : isVerity ? 'SYSTEM' : 'MONITORS';
            draft.deepLinkMonitorType = deepLinkMonitorType;
            draft.loading = false;
        });

        setReady(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setState]);

    return ready;
};
